import React from 'react';
import Icon from '../../../components/AppIcon';

const EventFormHeader = ({ onSaveDraft, onPreview, isSaving, lastSaved }) => {
  return (
    <div className="bg-card border-b border-border px-4 md:px-6 lg:px-8 py-4 md:py-5 lg:py-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-1 md:mb-2">
              Yeni Etkinlik Oluştur
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              SUP topluluğu için etkinlik detaylarını doldurun
            </p>
          </div>
          
          <div className="flex items-center gap-3">
            {lastSaved && (
              <span className="text-xs md:text-sm text-muted-foreground hidden sm:block">
                Son kaydedilme: {lastSaved}
              </span>
            )}
            
            <button
              onClick={onSaveDraft}
              disabled={isSaving}
              className="flex items-center gap-2 px-4 py-2 text-sm md:text-base font-medium text-foreground bg-muted hover:bg-muted/80 rounded-lg transition-smooth disabled:opacity-50"
            >
              <Icon name={isSaving ? "Loader2" : "Save"} size={18} className={isSaving ? "animate-spin" : ""} />
              <span className="hidden sm:inline">Taslak Kaydet</span>
            </button>
            
            <button
              onClick={onPreview}
              className="flex items-center gap-2 px-4 py-2 text-sm md:text-base font-medium text-primary bg-primary/10 hover:bg-primary/20 rounded-lg transition-smooth"
            >
              <Icon name="Eye" size={18} />
              <span className="hidden sm:inline">Önizle</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventFormHeader;